import { Injectable } from "@angular/core";
declare global {
    interface Array<T> {
        merge(array, compare): Array<T>;
        leftOuterJoin(array, key, callback): Array<T>;
    }
}

Array.prototype.merge = function (array, compare) {

    let result = new Array();
    while ((this.length > 0) && (array.length > 0)) {
        result.push(compare(this[0], array[0]) ? this.shift() : array.shift());
    }

    while (this.length > 0) {
        result.push(this.shift());
    }

    while (array.length > 0) {
        result.push(array.shift());
    }

    return result;
}

Array.prototype.leftOuterJoin = function(array, key, callback) {
    let keys = {};
    array.forEach(element => keys[element[key]] = element);
    return this.filter(element => callback(element, keys));
}

@Injectable()
export class Extensions { }